<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-card class="elevation-12">
          <v-card-title> Completed Todos </v-card-title>
          <v-card-subtitle> Total: {{ todos.length }}</v-card-subtitle>
          <v-card-text>
            <v-divider />
            <v-list v-if="todolist.length">
              <div :key="todo.id" v-for="todo in todolist">
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="todo.completed"
                      @change="completed(todo.id, $event)"
                      off-icon="mdi-circle-outline"
                      on-icon="mdi-check"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <span class="todo-text body-1">{{ todo.text }}</span>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn @click="removeTodo(todo)" color="red" icon>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider />
              </div>
            </v-list>
            <div v-else-if="searchQuery !== ''">
              <v-row>
                <v-col>
                  <p class="text-center body-1 mt-4">
                    No tasks found that contain "{{ searchQuery }}"
                  </p>
                </v-col>
              </v-row>
              <v-divider />
            </div>
            <div v-else>
              <v-row>
                <v-col>
                  <p class="body-1 text-center mt-5 mb-5">
                    Completed todos will show up here!
                  </p>
                  <v-img
                    :src="
                      $vuetify.theme.dark
                        ? require('../assets/images/completed-tasks-dark.svg')
                        : require('../assets/images/completed-tasks-light.svg')
                    "
                    alt="Empty todo list!"
                    width="200px"
                    class="mx-auto my-5"
                  ></v-img>
                </v-col>
              </v-row>
              <v-divider />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Completed',
  computed: {
    todos: function () {
      return this.$store.getters.completedTodos
    },
    todolist() {
      return this.todos.filter((todo) => todo.text.includes(this.searchQuery))
    },
  },
  methods: {
    removeTodo: function (todo) {
      this.$store.dispatch('editTodo', {
        id: todo.id,
        key: 'deleted',
        value: true,
      })
    },
    completed(id, completed) {
      this.$store.dispatch('editTodo', {
        id,
        key: 'completed',
        value: completed,
      })
    },
  },
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.todo-text {
  text-decoration-line: line-through;
}
</style>
